<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'
import ColorFieldRow from '../ColorFieldRow.vue'
import useBrandAppConfig from '../../composables/useBrandAppConfig'
import useColorPreview from '../../composables/useColorPreview'

const { t } = useI18n()

const props = defineProps<{
  primary: string
  buttonColor?: string
  effectiveButtonColor: string
  hideTitle?: boolean
}>()

const emit = defineEmits<{
  'update:primary': [value: string]
  'update:buttonColor': [value: string | undefined]
}>()

const { home, updateHome, homeDressing } = useBrandAppConfig()
const { setColorPreviewed } = useColorPreview()

onBeforeUnmount(() => setColorPreviewed(false))

const followsBrandColor = computed(() => props.buttonColor === undefined)

const textColor = computed(() => home.value.dressing.homeTextColor ?? homeDressing.value.homeTextColor.value)

const followsDerivedText = computed(() => home.value.dressing.homeTextColor === undefined)

const setTextColor = (value: string | undefined) => {
  updateHome('dressing', { ...home.value.dressing, homeTextColor: value })
}
</script>

<template>
  <PanelGroup :title="hideTitle ? undefined : t('pages.loyaltySupports.webapp.editor.design.colors.title')">
    <div class="flex flex-col gap-4">
      <ColorFieldRow
        id="brandApp.primary"
        :label="t('pages.loyaltySupports.webapp.editor.design.colors.brand')"
        :model-value="primary"
        @update:model-value="emit('update:primary', $event)"
      />

      <ColorFieldRow
        id="brandApp.buttonColor"
        :label="t('pages.loyaltySupports.webapp.editor.design.colors.buttons')"
        :model-value="effectiveButtonColor"
        :reset-label="
          followsBrandColor ? undefined : t('pages.loyaltySupports.webapp.editor.design.colors.resetToBrand')
        "
        @update:model-value="emit('update:buttonColor', $event)"
        @update:open="setColorPreviewed"
        @reset="emit('update:buttonColor', undefined)"
      />

      <ColorFieldRow
        id="brandApp.home.dressing.homeTextColor"
        :label="t('pages.loyaltySupports.webapp.editor.design.colors.texts')"
        :model-value="textColor"
        :reset-label="
          followsDerivedText ? undefined : t('pages.loyaltySupports.webapp.editor.design.colors.resetToDerived')
        "
        @update:model-value="setTextColor"
        @reset="setTextColor(undefined)"
      />
    </div>
  </PanelGroup>
</template>
